import { render, staticRenderFns } from "./AssessmentRecordStaff.vue?vue&type=template&id=5cce07f2"
import script from "./AssessmentRecordStaff.vue?vue&type=script&lang=js"
export * from "./AssessmentRecordStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports